module.exports = __webpack_public_path__ + "1f07b95c956137cec7c5fe1c351822e3.pdf";